import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/auth": [6],
		"/auth/sign-in": [7],
		"/balances": [8],
		"/dashboard": [9,[2]],
		"/dashboard/achievements": [10,[2]],
		"/dashboard/leaderboard": [11,[2]],
		"/dashboard/missions": [12,[2]],
		"/dashboard/rewards": [13,[2]],
		"/dashboard/wallets": [14,[2]],
		"/explorer": [15],
		"/explorer/channels": [16],
		"/explorer/clients": [17],
		"/explorer/connections": [18],
		"/explorer/find-packet": [19],
		"/explorer/orbital": [20],
		"/explorer/packets": [21],
		"/explorer/packets/incomplete": [23],
		"/explorer/packets/[packet_hash]": [22,[3]],
		"/explorer/tokens": [24],
		"/explorer/transfers": [25],
		"/explorer/transfers/[packet_hash]": [26,[4]],
		"/faucet": [27],
		"/health": [28],
		"/nodes": [29],
		"/privacy-policy": [30],
		"/stake": [31],
		"/transfers": [36],
		"/transfer": [32],
		"/transfer/multisig": [33],
		"/transfer/native": [34],
		"/transfer/ts-packets": [35],
		"/yaps": [37]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';